module.exports = __webpack_public_path__ + "io.svg?31be5ae048bf00540c015f7a3262aa0d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/io.svg
// module id = 1281
// module chunks = 27